export function addOneDay(dateString: string | null): string | null {
    try {
        if(dateString === null || dateString === '')
            return null;
        // Parse the input string to a Date object
        const date = new Date(dateString + " 00:00:00");
        // Add one day (24 hours * 60 minutes * 60 seconds * 1000 milliseconds)
        date.setDate(date.getDate() + 1);
    
        // Format it back to "YYYY-MM-DD"
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const day = String(date.getDate()).padStart(2, '0');
        
        return `${year}-${month}-${day}`;
    } catch {
        return null;
    }
}

export function formatDateTime(dateString: string | Date | null): string | null {
    try {
        if (dateString === null || dateString === '')
            return null;
        
        const date = typeof dateString === 'string' ? new Date(dateString) : dateString;
        
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    } catch {
        return null;
    }
}
